<template>
  <div class="d-inline">
    <i
      class="fa fa-circle-o-notch fa-spin"
      v-if="! count && ! error"
    />
    <i
      class="fa fa-exclamation-triangle"
      title="Problema de conexão"
      v-else-if="error"
    />
    <span v-else>{{ count }}</span>
  </div>
</template>

<script>
export default {
  props: {
    segment: null,
  },

  data () {
    return {
      count: null,
      error: false,
    };
  },

  mounted () {
    this.getCount();
  },

  methods: {
    getCount () {
      this.$http.get(`/lead/segment/${this.segment.id}/count`)
        .then((response) => {
          this.count = response.data;
        })
        .catch(() => {
          this.error = true;
        });
    },
  },
};
</script>
